import Model from './model'

export default class VehicleModel extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/vehicle-model'
    }
}
